<mat-card>
<mat-card-title>
<span>{{payback.amount| currency:'NGN':'symbol-narrow'}} </span><span>{{payback.lp_number}}</span>
</mat-card-title>
<mat-card-footer>
<span></span>
<span>{{payback.createdAt |date:'medium' }}</span>
</mat-card-footer>
</mat-card>
